import { shippedStatuses } from './MaOrderDetail.models'
import { OrderStatus } from '../../types/OrderStatus'
import { OrderDto } from '../../types/swaggerTypes'

/** CLOS-14614: Place order again is only offered once the order has shipped. */
export const isPlaceOrderAgainDisabled = (
  order: OrderDto | undefined,
  isEnrolledProgram: boolean
): boolean =>
  !order ||
  !isEnrolledProgram ||
  !shippedStatuses.includes(order.orderStatus as OrderStatus)
